<template>
  <section v-if="data">
    <PagesCalendarSlugComponent
      :data="data"
      :parentTitle="parentData?.data?.attributes?.title"
    />

  </section>
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
defineI18nRoute({
  paths: {
    en: '/activities/[slug]',
    nl: '/activiteiten/[slug]'
  }
})

definePageMeta({
  layout: 'detail'
})

const i18nActiveIso = baseI18nGetActiveIso()

const queryOptions = baseStrapiGetSlugQueryObjectFromRoute()
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest', { query: { path: queryCalendarEntryBySlug(queryOptions) } }
  )
})

const { data: parentData } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest', { query: { path: queryCalendarPageTitle(i18nActiveIso) } }
  )
})

const attributes = baseStrapiGetAttributes(data)
const defaultOgImageUrl = baseStrapiGetAbsoluteFileUrl(attributes?.coverImage?.data?.attributes?.url, attributes?.coverImage?.data?.provider)
basePageSetHead(data, defaultOgImageUrl)

const router = useRouter()
if (error.value || !data?.value?.data?.length) {
  router.push('/')
}
</script>
